import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-top-bar">
        <div className="container">
          <span>Increase Your Practice's Revenue — Partner with Nexus Prime Group</span>
          <a href="tel:6570000000" className="btn-footer-cta">Contact Us</a>
        </div>
      </div>

      <div className="footer-body">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-section">
              <div className="footer-logo">Nexus Prime Group</div>
              <p>A premier Revenue Cycle Management partner deploying advanced, data-driven strategies to maximize your practice's bottom line.</p>
            </div>

            <div className="footer-section">
              <h4>Useful Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/team">Our Team</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Services</h4>
              <ul>
                <li><Link to="/services#credentialing">Credentialing & Contracting</Link></li>
                <li><Link to="/services#billing">Medical Billing</Link></li>
                <li><Link to="/services#denials">Claim Denial Management</Link></li>
                <li><Link to="/services#rcm">Full RCM Services</Link></li>
                <li><Link to="/services#qa">Quality Assurance</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Reach Us</h4>
              <ul className="contact-list">
                <li><span className="icon">✉</span> [email]</li>
                <li><span className="icon">📞</span> (657) 000-000</li>
                <li><span className="icon">📍</span> Texas, Block B</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>© 2026 Nexus Prime Group. All Rights Reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms and Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
